export default {"src":"/_next/static/media/KEY.b3e98ed6.svg","height":18,"width":18};